import React from "react";
import images from "../images/junaid.PNG";
import About from "./about";
import Services from "./services";
import Skill from "./skill";
import Blog from "./blog";
import Experience from "./experience";
import Profile from "./education";
import Now from "./now";
import SkillsMap from "./skills-map";
import Testimonials from "./testimonials";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaGithub,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
  FaArrowRight,
} from "react-icons/fa";

const Hero = () => {
  return (
    <>
      <header className="hero-modern" id="Home">
        <div className="hero-background">
          <div className="hero-gradient"></div>
          <div className="hero-grid-pattern"></div>
        </div>

        <div className="hero-center-modern">
          <motion.article
            className="hero-content-modern"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <motion.div
              className="hero-badge"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <span className="badge-dot"></span>
              Open to collaboration
            </motion.div>

            <motion.h1
              className="hero-title-modern"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              Hi, I'm <span className="hero-name-gradient">Junaid Ahmad</span>
            </motion.h1>

            <motion.h2
              className="hero-subtitle-modern"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              Senior Frontend Engineer | Tech Lead
            </motion.h2>

            <motion.p
              className="hero-description-modern"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              Leading frontend architecture and mobile app development across
              fintech and consumer products. Specializing in React, React
              Native, and scalable full-stack solutions that drive product
              innovation and deliver exceptional user experiences.
            </motion.p>

            <motion.div
              className="hero-actions-modern"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
            >
              <Link to="/contact">
                <motion.button
                  className="btn-primary-modern hero-cta-btn"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Let’s Connect <FaArrowRight />
                </motion.button>
              </Link>

              <Link to="/projects">
                <motion.button
                  className="btn-secondary-modern hero-secondary-btn"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  View Projects
                </motion.button>
              </Link>
            </motion.div>

            <motion.div
              className="hero-social-modern"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.6 }}
            >
              <a
                href="https://www.facebook.com/junaid4u.ahmad"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-social-link facebook"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.linkedin.com/in/juac08"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-social-link linkedin"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://github.com/juac08"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-social-link github"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-social-link instagram"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            </motion.div>
          </motion.article>

          <motion.article
            className="hero-image-modern"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.8, ease: "easeOut" }}
          >
            <div className="hero-image-wrapper">
              <div className="hero-image-glow"></div>
              <img
                src={images}
                alt="Junaid Ahmad"
                className="hero-photo-modern"
              />
            </div>
          </motion.article>
        </div>
      </header>
      <About />
      <SkillsMap />
      <Experience />
      <Services />
      <Testimonials />
      <Now />
      <Skill />
      <Profile />
      <Blog />
    </>
  );
};

export default Hero;
